import { Button, Container, styled, Typography } from '@mui/material'
import React from 'react'
import config from '../../config'
import PropTypes from 'prop-types'

const PREFIX = 'SingpassError'

export const classes = {
  containerTop: `${PREFIX}-container-top`,
  containerMid: `${PREFIX}-container-mid`,
  containerBottom: `${PREFIX}-container-bottom`,
  label: `${PREFIX}-label`,
  marginTop: `${PREFIX}-margin-top`,
  registerAnother: `${PREFIX}-register-another`,
  appstoreContainer: `${PREFIX}-appstore-container`,
}

export const styles = ({ theme }) => ({
  [`& .${classes.containerMid}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(5, 0, 3, 0),
    padding: theme.spacing(0, 3),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 20),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 30),
    },
  },
})

const StyledDiv = styled('div')(styles)

SingpassError.propTypes = {
  handleBack: PropTypes.func.isRequired,
}

function SingpassError({ handleBack }) {
  return (
    <StyledDiv>
      <Container className={classes.containerMid}>
        <img src={config.PUBLIC_URL + '/error_2.svg'} alt="icon" />
        <Typography
          variant="h2"
          color="primary"
          sx={{ m: '10px 0px', textAlign: 'center' }}
        >
          Service Unavailable
        </Typography>
        <Typography variant="subtitle2" textAlign="left">
          Sorry, we are unable to access MyInfo webpage right now. <br />
          <br />
          You can either go back and try again or select your ID type to proceed
          with the registration.
          <br />
          <br />
        </Typography>
        <Button
          variant="contained"
          color="primary"
          disabled={false}
          onClick={handleBack}
          sx={{ mr: false, width: { xs: '90%', md: '50%' } }}
        >
          Back
        </Button>
      </Container>
    </StyledDiv>
  )
}

export default SingpassError
